export const COUNTRIES = [
    { currencyCode: 'usd', countryCode: 'us', currencySymbol: '$' },
    { currencyCode: 'cad', countryCode: 'ca', currencySymbol: '$' },
];

const findCountryByFieldValue = (field, value) => COUNTRIES.find((country) => country[field] === value) || COUNTRIES[0];

export const getCountryByCountryCode = (countryCode) => findCountryByFieldValue('countryCode', countryCode);
export const getCountryByCurrencyCode = (currencyCode) => findCountryByFieldValue('currencyCode', currencyCode);
